import { LocalStorage } from "../models/LocalStorage";
import { apiGetIpConfig } from "./api";
import { EVENTS, callEvent } from "./event";
import { getParamUrl, historyPushState, removeURLParameter } from "./url";

export function detectLanguage(fixedMetaLang = false) {
  const storageLanguage = LocalStorage.getLanguage();
  let defaultLanguage = (storageLanguage || "en") === "vi" ? "vi" : "en";
  let locale = getParamUrl("hl");
  if (locale) {
    defaultLanguage = locale === "en" ? "en" : "vi";
  }
  if (/^\/vi\//.test(window.location.pathname)) {
    defaultLanguage = "vi";
  }
  if (/^\/en\//.test(window.location.pathname)) {
    defaultLanguage = "en";
  }
  if (storageLanguage !== defaultLanguage) {
    LocalStorage.setLanguage(defaultLanguage);
    callEvent(EVENTS.CHANGE_SETTING);
  }
  if (locale !== undefined) {
    const url = removeURLParameter(window.location.href, "hl");
    historyPushState(url, true);
  }
  if (!fixedMetaLang) {
    setMetaLang(defaultLanguage);
  }
  return defaultLanguage;
}

export function setupLanguage(callback = () => { }, isFirst = true, fixedMetaLang = false) {
  const defaultLanguage = detectLanguage(fixedMetaLang);
  const en = require("../_locales/en/messages.json");
  const vi = require("../_locales/vi/messages.json");

  if (isFirst) {
    $.i18n({
      locale: defaultLanguage,
    })
      .load({
        "en": en,
        "vi": vi
      });
  } else {
    $.i18n({
      locale: defaultLanguage,
    });
  }
  $("body").i18n();
  callback(defaultLanguage);
  return defaultLanguage;
}

const MAX_CACHE_LOCATION = 72 * 60 * 60 * 1000;

export const getLocationByIp = (callback) => {
  let countryCode = LocalStorage.getLocation();
  if (countryCode) {
    const arr = countryCode.split("|");
    if (arr.length === 2 && arr[0] && (Date.now() - arr[1]) < MAX_CACHE_LOCATION) {
      typeof callback === "function" && callback(arr[0]);
      return;
    }
  }

  apiGetIpConfig(
    (data) => {
      countryCode = data?.ip_country ? data.ip_country : "VN";
      if (data) {
        LocalStorage.setCurrencyList(data.currencies)
        LocalStorage.setShippingList(data.shipping_to)
        LocalStorage.setIpCountry(data.ip_country);
      }
      LocalStorage.setLocation(countryCode + "|" + Date.now());
      typeof callback === "function" && callback(countryCode);
    }
  )

  // $.get('https://ipinfo.io', function () { }, "json").always(function (resp) {
  //   countryCode = (resp && resp.country) ? resp.country : "VN";
  //   LocalStorage.setLocation(countryCode + "|" + Date.now());
  //   typeof callback === "function" && callback(countryCode);
  // });
}

export const setMetaLang = (language) => {
  document.querySelector("html").setAttribute("lang", language);
  const langMeta = document.querySelector("meta[http-equiv='content-language']");
  langMeta && langMeta.setAttribute("content", language);
}

export const setTranslateElement = ({ element, i18nKey = "", isHtml = false, isPlaceholder = false } = {}) => {
  if (!element?.length || !i18nKey) return;
  let key = isPlaceholder ? `[placeholder]${i18nKey}` : isHtml ? `[html]${i18nKey}` : i18nKey;
  if (isPlaceholder) {
    element.attr("placeholder", $.i18n(i18nKey));
    element.data("i18n", key);
    element.attr("data-i18n", key);
  } else {
    isHtml ? element.html($.i18n(i18nKey)) : element.text($.i18n(i18nKey));
    element.data("i18n", key);
    element.attr("data-i18n", key);
  }
}

/**
 * 
 * @param {[{element, i18nKey, isHtml, isPlaceholder}]} listTranslate 
 * @returns 
 */
export const setTranslateElements = (listTranslate = []) => {
  if (!listTranslate?.length) return;
  for (let index = 0; index < listTranslate.length; index++) {
    const item = listTranslate[index];
    setTranslateElement(item);
  }
}